import { render, staticRenderFns } from "./PartCategoryMultiDropdown.vue?vue&type=template&id=449aaee2"
import script from "./PartCategoryMultiDropdown.vue?vue&type=script&lang=ts"
export * from "./PartCategoryMultiDropdown.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports